import "./RoboticsLearningPathway.module.css";
import Header from "@/reusable_sections/Header";
import RoboticsHero from "./sections/RoboticsHero";
import QuickFacts from "./sections/QuickFacts";
import PathwayPhilosophyProgression from "./sections/PathwayPhilosophyProgression";
import PathwayOverviewRoadmap from "./sections/PathwayOverviewRoadmap";
import DuploFoundationTrack from "./sections/DuploFoundationTrack";
import EquipmentComparison from "./sections/EquipmentComparison";
import WhalesBotTrack from "./sections/WhalesBotTrack";
import LearningMethodologyAssessment from "./sections/LearningMethodologyAssessment";
import EnjoyAiPathway from "./sections/EnjoyAiPathway";
import ConsultationCTA from "./sections/ConsultationCTA";
import SensorToAutonomousJourney from "./sections/SensorToAutonomousJourney";
import Hp6Spotlight from "./sections/Hp6Spotlight";
import SkillsDevelopmentMatrix from "./sections/SkillsDevelopmentMatrix";
import FaqAccordion from "./sections/FaqAccordion";
import Footer from "@/reusable_sections/Footer";
export default function RoboticsLearningPathwayPage() {
  return <div>
      <Header />
      <RoboticsHero />
      <QuickFacts />
      <PathwayPhilosophyProgression />
      <PathwayOverviewRoadmap />
      <DuploFoundationTrack />
      <EquipmentComparison />
      <WhalesBotTrack />
      <SensorToAutonomousJourney />
      <Hp6Spotlight />
      <EnjoyAiPathway />
      <FaqAccordion />
      <LearningMethodologyAssessment />
      <ConsultationCTA />
      <SkillsDevelopmentMatrix />
      <Footer />
    </div>;
}